
function About(props) {
    return (
        <main className="center column">
            <h1 className="center">About</h1>
            <br/>
            <h6>Fish Problems is a resource to help aquarium enthusiasts find the solutions to their problems. Fish Problems is free to use and is not responsible for any fish deaths or damage.</h6>
        </main>
    )
}

export default About